import React, { Suspense, lazy } from 'react';
import { observer } from 'mobx-react';
import HeroSection from "./home/components/HeroSection";
import AboutUsSection from "./home/components/AboutUsSection";
import SpecialtiesSection from "./home/components/SpecialtiesSection";
import ContactSection from "./home/components/ContactSection";
import "./home/home.css"
import { languageStore } from '../subscriber/Language';
import SignatureDish from './portfolio/components/SignatureDish';
import SeoHelmet from '../components/SeoHelmet';
import staticBlogs from '../data/blogs.json';
import Layout from "./layout"

// ✅ Dynamically import ServicesSection with SSR disabled
const ServicesSection = lazy(() => import('./home/components/ServicesSection'), {
    ssr: false,
    loading: () => <div>Loading services...</div>,
});

const TestimonialsSection = lazy(() => import('./home/components/TestimonialsSection'), {
    ssr: false,
    loading: () => <div>Loading testimonials...</div>,
});

const BlogSection = lazy(() => import('./home/components/BlogSection'), {
    ssr: false,
    loading: () => <div>Loading blog...</div>,
});

const HomePage = () => {
    const { getPageTranslations } = languageStore;
    const portfolio = getPageTranslations('portfolio');
    const services = getPageTranslations('services');
    const home = getPageTranslations('home');
    const contact = getPageTranslations('contact');
    // const social = getPageTranslations('social');
    
    const { about, blog, hero, specialties } = home;
    
    // 👇 SEO meta only from Home
    const seoHome = staticBlogs.find(b => b.slug === 'home');
    return (
        <Layout>
            <SeoHelmet
                title={seoHome.name}
                description={seoHome.sort_description}
                image={seoHome.path}
                url={seoHome.url}
            />
            <div className="bg-white">
                <Suspense fallback={<div>Loading...</div>}>
                    <HeroSection t={hero} />
                    <AboutUsSection t={about} />
                    <BlogSection t={blog}/>
                    <SpecialtiesSection t={specialties}/>
                    <TestimonialsSection />
                    <ServicesSection t={services} />
                    <SignatureDish t={portfolio}/>
                    {/* <SocialSection t={social}/> */}
                    <ContactSection t={contact} />
                </Suspense>
            </div>
        </Layout>
    );
};

export default observer(HomePage);
